// NPM Imports
import { COMMON } from "../constants";

// Destructuring
const { TABLE_TYPE } = COMMON;

// Declarations
const DEFAULT_STATE = {
  dealTableId: 0,
  documentId: 0,
  pricelist: [],
  showPriceBook: false,
  tableType: TABLE_TYPE.DEAL_TABLE,
  view: "DOCUMENT",
  htmlString: "",
  tabViewType: "",
  googleSheetId: "",
  excelSheetId: "",
};

/**
 * * INDEX
 * - FETCH_PRICELIST_ON_POPUP
 * - NUKE_QUOTATION_DATA
 * - QUOTATION_ADD_DEALTABLE_TAB
 * - QUOTATION_TOGGLE_PRICEBOOK_SELECTION_VIEW
 * - REACTION_ON_ADDING_DEALTABLE_TO_DOCUMENT
 * - REACTION_ON_DOCUMENT_PAGE_LOAD
 * - TOGGLE_QUOTATION_TAB_VIEW
 */

// ======================================================================

export default (state = { ...DEFAULT_STATE }, action) => {
  switch (action.type) {
    case "FETCH_PRICELIST_ON_POPUP":
      return Object.assign({}, state, { pricelist: action.payload });
    case "NUKE_QUOTATION_DATA":
      return Object.assign({}, state, { ...DEFAULT_STATE });
    case "QUOTATION_ADD_DEALTABLE_TAB":
      return Object.assign({}, state, {
        tableType: TABLE_TYPE.DEAL_TABLE,
        showPriceBook: true,
      });
    case "QUOTATION_TOGGLE_PRICEBOOK_SELECTION_VIEW":
      return Object.assign({}, state, {
        showPriceBook: !state.showPriceBook,
      });
    case "REACTION_ON_ADDING_DEALTABLE_TO_DOCUMENT":
      return Object.assign({}, state, {
        dealTableId: action.payload.dealTableId,
        showPriceBook: false,
        tableType: action.payload.tableType,
      });
    case "REACTION_ON_DOCUMENT_PAGE_LOAD":
      return Object.assign({}, state, {
        dealTableId: action.payload.dealTablePayload.dealTableId,
        documentId: action.payload.documentPayload.docDetails.id,
        showPriceBook: action.payload.dealTablePayload.showPriceBook,
        tableType: action.payload.dealTablePayload.tableType,
      });
    case "TOGGLE_QUOTATION_TAB_VIEW":
      return Object.assign({}, state, {
        view: action.payload.view,
        dealTableId:
          action.payload.dealTableId !== undefined
            ? action.payload.dealTableId
            : state.dealTableId,
        tabViewType: action.payload.tabViewType,
        googleSheetId: action.payload.googleSheetId,
        showPriceBook: action.payload.showPriceBook || state.showPriceBook,
        tableType: action.payload.tableType || state.tableType,
        excelSheetId: action.payload.excelSheetId,
        tableId: action.payload.tableId,
      });
    case "NUKE_QUOTETABLE_DATA":
      return Object.assign({}, state, {
        dealTableId: undefined,
        showPriceBook: undefined,
        tableType: undefined,
      });
    case "UPDATE_DOCUMENT_HTML_STRING":
      return Object.assign({}, state, {
        htmlString: action.payload.htmlString,
      });
    default:
      return state;
  }
};
